export default "__VITE_ASSET__LFOdoMiY__"